<template>
  <div>
    <el-drawer title="消息通知" :visible.sync="drawer">
      <div style="padding: 10px">
        <div v-if="messageLen > 0">
          <el-button type="primary" @click="showDialog" style="
              color: white;
              border: none;
              width: 100%;
              padding: 10px 100px;
              text-align: center;
            ">
            一键取消提醒
          </el-button>
        </div>
        <el-card class="box-card" v-for="(item, index) in messageList" :key="item.taskId">
          <div slot="header" class="clearfix">
            <span style="font-weight: bold">{{ item.title }}</span>
          </div>
          <div>
            {{ item.content }}
            <div style="font-size: 12px; margin-top: 10px;text-align: right;">创建时间：{{ item.createTime }}</div>
          </div>

          <div style="margin-top: 20px; display: flex; justify-content: center">
            <el-button type="danger" size="small" @click="closeMessage(item.taskId, item.title, index)"
              style="color: white; background-color: red">
              取消提醒
            </el-button>
          </div>
        </el-card>
      </div>
    </el-drawer>

    <el-tooltip effect="dark" content="消息" placement="bottom">
      <div @click="showMessage">
        <el-badge :value="messageLen == 0 ? undefined : messageLen" class="item d2-mr btn-text can-hover">
          <d2-icon name="envelope-o" class="d2-mr-5" />
        </el-badge>
      </div>
    </el-tooltip>

    <el-dialog title="提示" :visible.sync="isShowDialog" width="30%" center>
      <div style="text-align: center">确定取消当前所有的消息提醒吗</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowDialog = false">取 消</el-button>
        <el-button type="primary" @click="closeAllMessage">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { cancelSend } from "@/api/czManager/czMessage/index";
import { getEmailNotify } from "@/api/czManager/czMessage/index";
export default {
  data() {
    return {
      messageLen: 0,
      drawer: false,
      messageList: [],
      isShowDialog: false,
      isFaild: false,
      c: 0,
    };
  },
  methods: {
    showDialog() {
      this.isShowDialog = true;
    },
    closeAllMessage() {
      let len = this.messageList.length;
      for (let i = 0; i < len; i++) {
        this.closeMessage(
          this.messageList[i].taskId,
          this.messageList[i].title
        );
      }
      this.isShowDialog = false;
      if (!this.isFaild) {
        this.messageLen = 0;
      }
    },
    closeMessage(taskId, title, index) {
      cancelSend(taskId, title).then((response) => {
        if (response.statusCode == 2000) {
          //取消成功
          this.$message({
            duration: 5000,
            message: response.message,
            type: "success",
          });
          this.getMessage();
          //   for(let i = 0 ; i < this.messageList.length; i++){
          //             if(this.messageList[i].taskId === taskId){
          //                 console.log('this',this.messageList)
          //                 this.messageList.splice(index,1)
          //             }
          //   }
          //   this.messageLen = this.messageList.length
        } else {
          this.isFaild = true;
        }
      });
    },
    showMessage() {
      this.drawer = true;
      this.isFaild = false;
      this.getMessage();
    },
    getMessage() {
      this.messageList = []
      getEmailNotify().then((res) => {
        // for (let i = 0; i < res.length; i++) {
        this.messageLen = res.length;
        this.messageList = res;
        // }
        // let t;
        // if (this.c + 1 == 2) {
        //   return;
        // } else {
        //  this.c++
        //   for (let i = 0; i < 4; i++) {
        //     t.push({
        //       taskId: i,
        //       content: "sssssss",
        //       title: i,
        //     });
        //     this.messageLen = 4;

        //   }
        // }
      });
    },
  },
  created() {
    this.getMessage();
  },
};
</script>

<style>
.el-badge__content {
  top: 10px !important;
}

.el-dialog__close {
  color: #000 !important;
}

.box-card {
  margin: 5px;
  padding: 10px;
}
</style>